export default "__VITE_ASSET__4736b057__"